import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import UniversalInvoicePrint from "./UniversalInvoicePrint";
import api from "../Service/api";
import "./Purchases.css";

function ViewSalesReturn() {

  const getLocalDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formatToDateOnly = (datetime) => {
    if (!datetime) return '-';
    if (typeof datetime === 'string' && datetime.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return datetime;
    }
    try {
      const date = new Date(datetime);
      if (isNaN(date.getTime())) return '-';
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } catch (e) {
      return '-';
    }
  };

  // Helper to sort invoices descending by invoice number
const sortInvoicesDesc = (arr) => {
  return arr.sort((a, b) => (parseInt(b.invoiceNumber) || 0) - (parseInt(a.invoiceNumber) || 0));
};

  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updateInvoice, setUpdateInvoice] = useState(null);
  const [allProducts, setAllProducts] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [startDate, setStartDate] = useState(getLocalDate)
  const [endDate, setEndDate] = useState(getLocalDate)

  const [searchText, setSearchText] = useState("");
  const [filteredInvoices, setFilteredInvoices] = useState([]);

  const printRef = useRef();
  const [printInvoice, setPrintInvoice] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [loadingVendors, setLoadingVendors] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [selectedCustomerBalance, setSelectedCustomerBalance] = useState(null);
  const [loadingCustomers, setLoadingCustomers] = useState(true);

  const refreshProductList = async () => {
    setLoadingProducts(true);
    try {
      const res = await api.get("/product/names-prices");
      if (res.data.code === 1) {
        setAllProducts(res.data.additionalDetail);
        console.log("✅ Product list refreshed with latest stock quantities");
      }
    } catch (err) {
      console.error("Error refreshing product list", err);
    } finally {
      setLoadingProducts(false);
    }
  };
  
  useEffect(() => {
    const phone = localStorage.getItem("userPhone");
    console.log("PHONE FROM LOCALSTORAGE:", phone);
    
    if (!phone) return;
    
    api.get(`/authentication/userData/${phone}`)
      .then(res => {
        console.log("USER DATA API RESPONSE:", res.data);
        setLoggedInUser(res.data.additionalDetail);
      })
      .catch(err => console.error("USER DATA API ERROR:", err));
  }, []);
  
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: printInvoice ? `Invoice-${printInvoice.invoiceNumber}` : "Invoice",
  });
  
  const handlePrintInvoice = (invoice) => {
    const copy = JSON.parse(JSON.stringify(invoice));

    copy.user = loggedInUser;

    copy.products = (copy.sales || copy.products || []).map((p) => ({
      ...p,
      calculatedTotal: computeProductTotal(p),
    }));

    copy.payBill = invoice.payBill ?? invoice.amountPaid ?? 0;

    copy.gstPercentage = invoice.gstPercentage ?? 0;
    copy.gstAmount = invoice.gstAmount ?? 0;
    copy.totalBeforeGst = invoice.totalBeforeGst ?? 0;

    copy.grandTotal = computeInvoiceGrandTotal(copy);

    setPrintInvoice(copy);

    setTimeout(() => handlePrint(), 300);
  };

  useEffect(() => {
    loadInitialData();
    loadPurchases();
  }, []);

  const loadInitialData = async () => {
    try {
      setLoadingProducts(true);
      const productsRes = await api.get("/product/names-prices");
      if (productsRes.data.code === 1) {
        setAllProducts(productsRes.data.additionalDetail);
      }
      setLoadingProducts(false);

      setLoadingCategories(true);
      const categoriesRes = await api.get("/api/category/getCategories");
      if (categoriesRes.data.code === 1) {
        setCategoryList(categoriesRes.data.additionalDetail || []);
      } else {
        setCategoryList([
          { categoryName: "packet" }, { categoryName: "roll" }, { categoryName: "reel" },
          { categoryName: "tota" }, { categoryName: "box" }, { categoryName: "kg" }, { categoryName: "bottle" },
        ]);
      }
      setLoadingCategories(false);

      setLoadingVendors(true);
      const vendorsRes = await api.get("/product/getAll");
      if (vendorsRes.data.code === 1 && Array.isArray(vendorsRes.data.additionalDetail)) {
        setVendorList(vendorsRes.data.additionalDetail);
      }
      setLoadingVendors(false);
    } catch (err) {
      console.error("Error loading initial data", err);
      setLoadingProducts(false);
      setLoadingCategories(false);
      setLoadingVendors(false);
    }
  };

  useEffect(() => {
    setLoadingCustomers(true);
    api.get("/product/getAllCustomers")
      .then(res => {
        if (res.data.code === 1 && Array.isArray(res.data.additionalDetail)) {
          setCustomerList(res.data.additionalDetail);
          console.log("✅ Loaded customers with balances:", res.data.additionalDetail);
        }
      })
      .catch(err => console.error("Failed to fetch customers", err))
      .finally(() => setLoadingCustomers(false));
  }, []);

  useEffect(() => {
    if (loading === false) {
      loadPurchases();
    }
  }, [startDate, endDate]);

  useEffect(() => {
  const handleWheel = (e) => {
    if (e.target.type === 'number') {
      e.preventDefault();
    }
  };
  document.addEventListener('wheel', handleWheel, { passive: false });
  return () => document.removeEventListener('wheel', handleWheel);
}, []);

 const loadPurchases = async () => {
  try {
    const params = { status: "Return" };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const res = await api.get("/product/sales/by-category-and-name", { params });
    const raw = res.data.code === 1 ? res.data.additionalDetail || [] : [];

    // ✅ Filter out inactive invoices AND strip inactive products
    const activeOnly = raw
      .filter(inv => inv.isActive !== false)          // invoice-level flag
      .map(inv => ({
        ...inv,
        sales: (inv.sales || []).filter(p => p.isActive !== false), // product-level flag
      }))
      .filter(inv => inv.sales.length > 0);            // drop invoices with no active products

    const sortedData = sortInvoicesDesc(activeOnly);
    setInvoices(sortedData);
    setFilteredInvoices(sortedData);
  } catch (err) {
    console.error("Error fetching purchases", err);
    setInvoices([]);
    setFilteredInvoices([]);
  } finally {
    setLoading(false);
  }
};

  const handleSearch = (text) => {
  setSearchText(text);

  // Start from the already-filtered list
  if (!text) {
    setFilteredInvoices(invoices);
    return;
  }

  const filtered = invoices.filter(inv => {
    if (inv.isActive === false) return false;          // ✅ guard
    const customerMatch = inv.customerName?.toLowerCase().includes(text.toLowerCase());
    const productMatch = (inv.sales || []).some(
      p => p.isActive !== false && p.productName?.toLowerCase().includes(text.toLowerCase())
    );
    const invoiceMatch =
      inv.invoiceNumber?.toString().includes(text) ||
      inv.invoiceNumber?.toString().toLowerCase().includes(text.toLowerCase());
    return customerMatch || productMatch || invoiceMatch;
  });

  setFilteredInvoices(sortInvoicesDesc(filtered));
};

  const resetFilters = () => {
    setStartDate("");
    setEndDate("");
    setSearchText("");
    loadPurchases();
  };

  const computeProductTotal = (prod) => {
    const category = (prod.category || "").toLowerCase();
    const price = parseFloat(prod.price) || 0;
    const quantity = parseFloat(prod.returnedQuantity) || 0;
    const size = parseFloat(prod.size) || 1;
    const ktae = parseFloat(prod.ktae) || 1;
    const gram = parseFloat(prod.gram) || 1;
    let total = 0;
    if (category === "packet") total = (quantity * size * ktae * gram * price) / 15500;
    else if (category === "roll") total = size * quantity * price;
    else if (category === "reel" || category === "tota") total = quantity * price;
    else if (category === "box") total = price * quantity;
    else total = price * quantity;
    if (prod.generalDiscount) total -= parseFloat(prod.generalDiscount) || 0;
    return Number(total.toFixed(2));
  };

  const openUpdateForm = (invoice) => {
    const copy = JSON.parse(JSON.stringify(invoice || {}));

    copy.sales = (copy.sales || []).map((p) => ({
      ...p,
      returnedQuantity: p.returnedQuantity ?? 0,
      price: p.price ?? 0,
      size: p.size ?? "",
      length: p.length ?? "",
      ktae: p.ktae ?? "",
      gram: p.gram ?? "",
      boxSize: p.boxSize ?? "",
      particular: p.particular ?? "",
      generalDiscount: p.generalDiscount ?? "",
      calculatedTotal: computeProductTotal(p),
    }));

    copy.customerName = invoice.customerName ?? "";
    copy.invoiceDiscount = invoice.invoiceDiscount ?? 0;
    copy.invoiceRent = invoice.invoiceRent ?? 0;
    copy.description = invoice.description ?? "";
    copy.gstPercentage = invoice.gstPercentage ?? 0;
    copy.gstAmount = invoice.gstAmount ?? 0;
    copy.totalBeforeGst = invoice.totalBeforeGst ?? 0;
    copy.invoiceDate = invoice.invoiceDate || getLocalDate();

    copy.grandTotal = computeInvoiceGrandTotal(copy);

    setSelectedCustomerBalance(null);
    setUpdateInvoice(copy);
  };

  const handleUpdateCustomerChange = (e) => {
    const name = e.target.value;
    setUpdateInvoice(prev => ({ ...prev, customerName: name }));
    const customer = customerList.find(c => c.customerName === name);
    if (customer && customer.currentBalance !== undefined) {
      setSelectedCustomerBalance(customer.currentBalance);
    } else {
      setSelectedCustomerBalance(null);
    }
  };

  const computeInvoiceGrandTotal = (invoice) => {
    if (!invoice) return 0;
    const productsTotal = (invoice.sales || []).reduce((total, p) => {
      const category = (p.category || "").toLowerCase();
      const price = parseFloat(p.price) || 0;
      const quantity = parseFloat(p.returnedQuantity) || 0;
      const size = parseFloat(p.size) || 1;
      const ktae = parseFloat(p.ktae) || 1;
      const gram = parseFloat(p.gram) || 1;
      let productTotal = 0;
      if (category === "packet") productTotal = (quantity * price * size * ktae * gram) / 15500;
      else if (category === "roll") productTotal = quantity * price * size;
      else if (category === "reel" || category === "tota") productTotal = quantity * price;
      else if (category === "box") productTotal = quantity * price;
      else productTotal = quantity * price;
      if (p.generalDiscount) productTotal -= parseFloat(p.generalDiscount) || 0;
      return total + productTotal;
    }, 0);
    const discount = invoice.invoiceDiscount === "" || invoice.invoiceDiscount == null ? 0 : Number(invoice.invoiceDiscount);
    const rent = invoice.invoiceRent === "" || invoice.invoiceRent == null ? 0 : Number(invoice.invoiceRent);
    let grandTotal = productsTotal - discount + rent;
    if (invoice.gstPercentage != null && invoice.gstPercentage !== "") {
      const gstPercent = parseFloat(invoice.gstPercentage) || 0;
      if (gstPercent > 0) {
        const gstAmount = (grandTotal * gstPercent / 100);
        grandTotal += gstAmount;
      }
    }
    return Number(grandTotal.toFixed(2));
  };

  const handleUpdateProductChange = (index, field, value) => {
    if (!updateInvoice) return;
    const sales = [...updateInvoice.sales];
    const prod = { ...sales[index] };
    prod[field] = value;

    if (field === "productName") {
      const match = allProducts.find(
        (ap) => (ap.productName || "").toLowerCase() === value.toLowerCase()
      );
      if (match) {
        prod.price = match.sellPrice ?? prod.price;
        prod.category = match.category ?? prod.category;
        if (match.category && match.category.toLowerCase() === 'roll' && match.size) {
          prod.size = match.size;
        }
      }
    }

    const currentCategory = (prod.category || "").toLowerCase();
    if (field === "returnedQuantity" && (currentCategory === "reel" || currentCategory === "tota" || currentCategory === "roll")) {
      const valueNum = parseFloat(value) || 0;
      prod.size = valueNum;
    }

    if (field === "category") {
      const cat = (value || "").toLowerCase();
      if (cat !== "packet") {
        prod.ktae = "";
        prod.gram = "";
      }
      if (cat !== "box") {
        prod.boxSize = "";
      }
      if (!["packet", "roll", "reel", "tota", "box"].includes(cat)) {
        prod.size = "";
      }
      if (cat !== 'reel' && cat !== 'tota') {
        prod.length = '';
      }
    }

    prod.calculatedTotal = computeProductTotal(prod);
    sales[index] = prod;

    const updatedInvoice = { ...updateInvoice, sales };
    updatedInvoice.grandTotal = computeInvoiceGrandTotal(updatedInvoice);
    setUpdateInvoice(updatedInvoice);
  };

  const handleUpdateInvoiceField = (field, value) => {
    if (!updateInvoice) return;
    const updated = { ...updateInvoice, [field]: value };
    updated.grandTotal = computeInvoiceGrandTotal(updated);
    setUpdateInvoice(updated);
  };

  const validateVendorForReelTotaRoll = () => {
    if (!updateInvoice) return true;
    for (let i = 0; i < updateInvoice.sales.length; i++) {
      const p = updateInvoice.sales[i];
      const cat = (p.category || "").toLowerCase();
      if ((cat === "reel" || cat === "tota") && (!p.particular || p.particular.trim() === "")) {
        alert(`Vendor name is required for ${p.productName} (Row ${i + 1})`);
        return false;
      }
    }
    return true;
  };

  const renderStockDisplay = (selectedProduct, productName, category) => {
  if (!selectedProduct || !productName) return null;
  
  const cat = (selectedProduct.category || "").toLowerCase();
  const isReelTota = cat === 'reel' || cat === 'tota';
  const isRollCat = cat === 'roll';
  const isPacketCat = cat === 'packet';
  
  if ((isReelTota || isRollCat) && selectedProduct.stockByWeight && Object.keys(selectedProduct.stockByWeight).length > 0) {
    const stockEntries = Object.entries(selectedProduct.stockByWeight).filter(([_, qty]) => qty > 0);
    if (stockEntries.length === 0) {
      return <div style={{ color: '#ff4444', backgroundColor: '#ffebee', padding: '6px 8px', borderRadius: '4px', marginTop: '4px', border: '1px solid #ff4444', fontSize: '11px' }}><strong>⚠️ Out of Stock</strong></div>;
    }
    return (
      <div style={{ color: '#0a8938', backgroundColor: '#f8f9fa', padding: '6px 8px', borderRadius: '4px', marginTop: '4px', border: '1px solid #0a8938', fontSize: '11px' }}>
        <strong style={{ fontSize: '10px', display: 'block', marginBottom: '4px' }}>📊 Available Stock:</strong>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {stockEntries.map(([display, qty]) => (
            <span key={display} style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '12px', fontSize: '10px', fontWeight: 'bold' }}>
              {display}: <span style={{ color: '#2e7d32' }}>{qty}</span>
            </span>
          ))}
        </div>
      </div>
    );
  } else if (isPacketCat && selectedProduct.packetStockByVariant && Object.keys(selectedProduct.packetStockByVariant).length > 0) {
    const totalStock = selectedProduct.stockQuantity || 0;
    const variantEntries = Object.entries(selectedProduct.packetStockByVariant).filter(([_, qty]) => qty > 0);
    if (totalStock <= 0) {
      return <div style={{ color: '#ff4444', backgroundColor: '#ffebee', padding: '6px 8px', borderRadius: '4px', marginTop: '4px', border: '1px solid #ff4444', fontSize: '11px' }}><strong>⚠️ Out of Stock</strong></div>;
    }
    return (
      <div style={{ color: '#0a8938', backgroundColor: '#f8f9fa', padding: '6px 8px', borderRadius: '4px', marginTop: '4px', border: '1px solid #0a8938', fontSize: '11px' }}>
        <div><strong>📦 Total Stock: {totalStock}</strong></div>
        {variantEntries.length > 0 && (
          <>
            <div style={{ fontSize: '10px', marginTop: '4px', color: '#555' }}>Breakdown by variant:</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '2px' }}>
              {variantEntries.map(([variant, qty]) => (
                <span key={variant} style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '12px', fontSize: '9px', fontWeight: 'bold' }}>
                  {variant}: {qty}
                </span>
              ))}
            </div>
          </>
        )}
      </div>
    );
  } else if (selectedProduct.stockQuantity !== undefined && selectedProduct.stockQuantity > 0) {
    return <div style={{ fontSize: '11px', color: '#0a8938', marginTop: '2px' }}>📦 In Stock: {selectedProduct.stockQuantity}</div>;
  } else if (selectedProduct.stockQuantity !== undefined && selectedProduct.stockQuantity <= 0) {
    return <div style={{ fontSize: '11px', color: '#ff4444', marginTop: '2px' }}>📦 Out of Stock</div>;
  }
  return null;
};

  const saveUpdate = async () => {
    if (!updateInvoice) return alert("No invoice to update");
    if (!validateVendorForReelTotaRoll()) return;
    setIsUpdating(true);

    try {
      const toSend = JSON.parse(JSON.stringify(updateInvoice));

      toSend.products = (toSend.sales || []).map((p) => {
        const cat = (p.category || "").toLowerCase();
        const clean = { ...p };

        clean.returnedQuantity = parseFloat(p.returnedQuantity) || 0;
        
        if ((cat === "reel" || cat === "tota" || cat === "roll") && (!clean.size || clean.size === 0)) {
          clean.size = parseFloat(p.returnedQuantity) || 0;
        }

        if (cat === "reel" || cat === "tota") {
          clean.length = parseFloat(p.length) || 0;
        } else {
          delete clean.length;
        }

        if (!["packet", "roll", "reel", "tota", "box"].includes(cat)) {
          delete clean.size;
        }

        if (cat !== "packet") {
          delete clean.ktae;
          delete clean.gram;
        }

        if (cat !== "box") {
          delete clean.boxSize;
        }

        if (cat === "packet") {
          clean.particular = null;
        }

        clean.calculatedTotal = computeProductTotal(clean);
        return clean;
      });

      toSend.gstPercentage = updateInvoice.gstPercentage || null;
      toSend.gstAmount = updateInvoice.gstAmount || null;
      toSend.totalBeforeGst = updateInvoice.totalBeforeGst || null;

      const invoiceNum = toSend.invoiceNumber;
      
      const res = await api.put(`/product/saleUpdated/${invoiceNum}`, toSend, { 
        params: { status: "Return", invoiceDate: toSend.invoiceDate } 
      });

      alert(res.data.additionalDetail);
      setUpdateInvoice(null);
      setSelectedCustomerBalance(null);
      
      await refreshProductList();
      loadPurchases();
    } catch (err) {
      console.error("Update failed", err);
      alert("Update failed! See console.");
    } finally {
      setIsUpdating(false);
    }
  };

  const deleteInvoice = async (invoiceNum) => {
    if (!window.confirm(`Delete invoice ${invoiceNum}?`)) return;
    try {
      await api.delete(`/product/delete/sale/${invoiceNum}`, { params: { status: "Return" }});
      alert("Deleted!");
      loadPurchases();
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const showWeightLabel = updateInvoice?.sales?.some(p => {
    const cat = (p.category || "").toLowerCase();
    return cat === "reel" || cat === "tota" || cat === "roll";
  });

  if (loading) return <div className="loading-text">Loading…</div>;

  return (
    <div className="purchase-container">
      <h2 className="page-title">↩️ View Sales Returns</h2>

      {(loadingProducts || loadingCategories || loadingVendors || loadingCustomers) && (
        <div style={{ textAlign: 'center', padding: '10px', backgroundColor: '#e3f2fd', marginBottom: '10px', borderRadius: '4px' }}>
          ⏳ Loading data... {loadingProducts && "Products "} {loadingCategories && "Categories "} {loadingVendors && "Vendors "} {loadingCustomers && "Customers "}
        </div>
      )}

      <div style={{ marginBottom: 20 }}>
        <input
          type="text"
          placeholder="Search by product, customer, or invoice number..."
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          className="read-only-input"
          style={{ width: 300, padding: 6 }}
        />
      </div>

      <div style={{ marginBottom: 20, display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <label style={{ fontWeight: '500', color: '#000', fontSize: '14px' }}>From:</label>
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="read-only-input" style={{ padding: '6px', borderRadius: '4px' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <label style={{ fontWeight: '500', color: '#000', fontSize: '14px' }}>To:</label>
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="read-only-input" style={{ padding: '6px', borderRadius: '4px' }} min={startDate} />
        </div>
        <button onClick={resetFilters} className="remove-btn" style={{ padding: '6px 12px', fontSize: '14px', marginLeft: '10px' }}>Clear Filters</button>
        {(startDate || endDate || searchText) && (
          <span style={{ fontSize: '14px', color: '#555', marginLeft: '10px' }}>
            Showing {filteredInvoices.length} of {invoices.length} sales returns
            {searchText && ` for "${searchText}"`}
            {startDate && ` from ${startDate}`}
            {endDate && ` to ${endDate}`}
          </span>
        )}
      </div>

      {filteredInvoices.length === 0 && !loading && (
        <p style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
          {searchText || startDate || endDate ? "No sales returns found matching your search/filters." : "No sales returns found."}
        </p>
      )}

      {filteredInvoices.map((invoice) => {
        const products = invoice.sales || [];

        const categories = products.map(p => (p.category || "").toLowerCase());
        const hasPacket = categories.includes("packet");
        const hasRollOnly = categories.some(c => ["roll"].includes(c));
        const hasBox = categories.includes("box");
        const showParticularColumn = true;
        const hasReelOrTotaOrRoll = categories.some(c => c === "reel" || c === "tota");
        const showLengthColumn = categories.some(c => c === "reel" || c === "tota");
        // Show Size column if ANY product needs it (packet, roll, or reel/tota)
        const showSizeColumn = hasPacket || hasRollOnly || showLengthColumn;

        return (
          <div key={invoice.invoiceNumber} className="invoice-box">
            <h3 className="invoice-title" style={{ color: "#000" }}>
              Invoice #{invoice.invoiceNumber} – {invoice.customerName}
            </h3>

            {invoice.invoiceImagePath && (
              <div style={{ marginBottom: "10px", cursor: "pointer" }}>
                <img src={invoice.invoiceImagePath} alt={`Invoice ${invoice.invoiceNumber}`} style={{ maxWidth: "200px", maxHeight: "200px", border: "1px solid #ccc", padding: "5px", objectFit: "contain" }} onClick={() => setFullScreenImage(invoice.invoiceImagePath)} />
              </div>
            )}

            <div style={{ marginBottom: "10px", display: "flex", gap: "10px" }}>
              <button className="save-btn" onClick={() => openUpdateForm(invoice)}>Update</button>
              <button className="remove-btn" onClick={() => deleteInvoice(invoice.invoiceNumber)}>Delete</button>
              <button className="print-btn" onClick={() => handlePrintInvoice(invoice)} disabled={!invoice}>Print</button>
            </div>

            <div className="purchase-table-container">
              <div className="table-scroll-wrapper">
                <table className="purchase-table">
                  <thead>
                    <tr>
                      <th>Product</th><th>Category</th><th>Returned Qty</th><th>Rate</th>
                      <th>Return Date</th><th>Updated Date</th>
                      {/* SINGLE Size column - shown if packet, roll, or reel/tota products exist */}
                      {showSizeColumn && <th>Size</th>}
                      {hasPacket && (<><th>Ktae</th><th>Gram</th></>)}
                      {hasBox && <th>Box Size</th>}
                      {showParticularColumn && <th>{hasReelOrTotaOrRoll ? "Vendor Name" : "Particular"}</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((p, idx) => {
                      const category = (p.category || "").toLowerCase();
                      const shouldShowParticular = category === "reel" || category === "tota";
                      const isRoll = category === 'roll';
                      const isPacket = category === 'packet';
                      const isReelOrTota = category === 'reel' || category === 'tota';
                      
                      // Determine what to show in the Size column
                      let sizeDisplay = '-';
                      if (isPacket || isRoll) {
                        sizeDisplay = p.size || '-';
                      } else if (isReelOrTota) {
                        sizeDisplay = p.length || '-';
                      }
                      
                      return (
                        <tr key={idx}>
                          <td>{p.productName}</td>
                          <td>{p.category}</td>
                          <td>{p.returnedQuantity}</td>
                          <td>{p.price}</td>
                          <td>{formatToDateOnly(p.returnTime)}</td>
                          <td>{formatToDateOnly(p.recordUpdatedTime)}</td>
                          {/* SINGLE Size column */}
                          {showSizeColumn && <td>{sizeDisplay}</td>}
                          {hasPacket && (
                            <>
                              <td>{isPacket ? (p.ktae || '-') : '-'}</td>
                              <td>{isPacket ? (p.gram || '-') : '-'}</td>
                            </>
                          )}
                          {hasBox && (
                            <td>{category === 'box' ? (p.boxSize || '-') : '-'}</td>
                          )}
                          {showParticularColumn && (
                            <td>
                              {category !== 'roll' ? (
                                shouldShowParticular ? (p.particular || '-') : (p.particular || '-')
                              ) : (
                                '-'
                              )}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            {/* UPDATE FORM */}
            {updateInvoice && updateInvoice.invoiceNumber === invoice.invoiceNumber && (
              <div className="invoice-box" style={{ background: "#fff7e6", marginTop: 12 }}>
                <h3 className="invoice-title">Update Invoice #{updateInvoice.invoiceNumber}</h3>

                <div style={{ marginBottom: 15, padding: "0 10px" }}>
                  <label style={{ fontWeight: "bold", marginRight: 10 }}>Return Date:</label>
                  <input type="date" value={updateInvoice.invoiceDate || getLocalDate()} onChange={(e) => handleUpdateInvoiceField("invoiceDate", e.target.value)} className="read-only-input" style={{ width: "200px" }} max={new Date().toISOString().split('T')[0]} />
                </div>

                <div className="purchase-table-container">
                  <div className="table-scroll-wrapper">
                    <table className="purchase-table">
                      <thead>
                        <tr>
                          <th>Product Name</th><th>Category</th>
                          <th>{showWeightLabel ? "Weight/Quantity" : "Return Qty"}</th>
                          <th>Rate</th>
                          {(() => {
                            const updateCategories = updateInvoice.sales.map(p => (p.category || "").toLowerCase());
                            const showPacket = updateCategories.includes("packet");
                            const showRoll = updateCategories.some(c => ["roll"].includes(c));
                            const showBox = updateCategories.includes("box");
                            const showParticular = true;
                            const showLength = updateCategories.some(c => c === "reel" || c === "tota");
                            const showSize = showPacket || showRoll || showLength;
                            return (
                              <>
                                {showSize && <th>Size</th>}
                                {showPacket && (<><th>Ktae</th><th>Gram</th></>)}
                                {showBox && <th>Box Size</th>}
                                {showParticular && <th>Vendor/Particular</th>}
                              </>
                            );
                          })()}
                        </tr>
                      </thead>
                      <tbody>
                        {updateInvoice.sales.map((p, idx) => {
                          const cat = (p.category || "").toLowerCase();
                          const updateCategories = updateInvoice.sales.map(p => (p.category || "").toLowerCase());
                          const showPacketColumns = updateCategories.includes("packet");
                          const showRollOnly = updateCategories.some(c => ["roll"].includes(c));
                          const showBoxColumns = updateCategories.includes("box");
                          const showParticularColumn = true;
                          const showLengthColumn = updateCategories.some(c => c === "reel" || c === "tota");
                          const showSize = showPacketColumns || showRollOnly || showLengthColumn;
                          const shouldShowParticular = cat === "reel" || cat === "tota";
                          const isReelOrTotaOrRoll = cat === "reel" || cat === "tota";
                          const isReelOrTota = cat === "reel" || cat === "tota";
                          const isPacket = cat === "packet";
                          const isRoll = cat === "roll";

                          const selectedProduct = allProducts.find(ap => ap.productName === p.productName);
                          const stockQuantity = selectedProduct?.stockQuantity;
                          const stockByWeight = selectedProduct?.stockByWeight;
                          const packetStockByVariant = selectedProduct?.packetStockByVariant;

                          let hasStock = true;
                          if (selectedProduct && p.productName) {
                            if (isReelOrTotaOrRoll && stockByWeight) {
                              hasStock = Object.values(stockByWeight).some(qty => qty > 0);
                            } else if (isPacket && packetStockByVariant) {
                              hasStock = Object.values(packetStockByVariant).some(qty => qty > 0);
                            } else {
                              hasStock = (stockQuantity !== undefined && stockQuantity > 0);
                            }
                          }

                          return (
                            <tr key={idx}>
                              <td style={{ position: 'relative' }}>
                                <input list={`sales-${idx}`} value={p.productName || ""} onChange={(e) => handleUpdateProductChange(idx, "productName", e.target.value)} className="read-only-input" style={{ borderColor: (!hasStock && p.productName) ? '#ff4444' : '', backgroundColor: (!hasStock && p.productName) ? '#fff0f0' : '' }} />
                                <datalist id={`sales-${idx}`}>
                                  {allProducts.map((ap, i) => {
                                    const apCategoryLower = (ap.category || "").toLowerCase();
                                    const isApReelOrTotaOrRoll = apCategoryLower === 'reel' || apCategoryLower === 'tota' || apCategoryLower === 'roll';
                                    const isApPacket = apCategoryLower === 'packet';

                                    if (isApReelOrTotaOrRoll && ap.stockByWeight && Object.keys(ap.stockByWeight).length > 0) {
                                      const nonZeroStocks = Object.entries(ap.stockByWeight).filter(([_, qty]) => qty > 0);
                                      if (nonZeroStocks.length > 0) {
                                        return <option key={i} value={ap.productName}>{ap.productName} [{nonZeroStocks.map(([weight, qty]) => `${weight}: ${qty}`).join(', ')}]</option>;
                                      } else {
                                        return <option key={i} value={ap.productName}>{ap.productName} (Out of Stock)</option>;
                                      }
                                    } else if (isApPacket && ap.packetStockByVariant && Object.keys(ap.packetStockByVariant).length > 0) {
                                      const nonZeroStocks = Object.entries(ap.packetStockByVariant).filter(([_, qty]) => qty > 0);
                                      if (nonZeroStocks.length > 0) {
                                        return <option key={i} value={ap.productName}>{ap.productName} [{nonZeroStocks.map(([variant, qty]) => `${variant}: ${qty}`).join(', ')}]</option>;
                                      } else {
                                        return <option key={i} value={ap.productName}>{ap.productName} (Out of Stock)</option>;
                                      }
                                    } else {
                                      return <option key={i} value={ap.productName}>{ap.productName} {ap.stockQuantity !== undefined ? `(Stock: ${ap.stockQuantity})` : ''}{ap.category === 'roll' && ap.size ? ` [Size: ${ap.size}]` : ''}</option>;
                                    }
                                  })}
                                </datalist>
                                  {renderStockDisplay(selectedProduct, p.productName, p.category)}

                                {p.productName && isPacket && selectedProduct && (
                                  <div style={{ marginTop: '4px' }}>
                                    {(() => {
                                      const totalStock = selectedProduct.stockQuantity || 0;
                                      const variantEntries = packetStockByVariant ? Object.entries(packetStockByVariant).filter(([_, qty]) => qty > 0) : [];
                                      const hasVariantStock = totalStock > 0;
                                      if (!hasVariantStock) {
                                        return <div style={{ color: '#ff4444', backgroundColor: '#ffebee', padding: '6px 8px', borderRadius: '4px', border: '1px solid #ff4444', fontSize: '11px' }}><strong>⚠️ Out of Stock</strong></div>;
                                      }
                                      return (
                                        <div style={{ color: '#0a8938', backgroundColor: '#f8f9fa', padding: '6px 8px', borderRadius: '4px', border: '1px solid #0a8938', fontSize: '11px' }}>
                                          <div><strong>📦 Total Stock: {totalStock}</strong></div>
                                          {variantEntries.length > 0 && (
                                            <>
                                              <div style={{ fontSize: '10px', marginTop: '4px', color: '#555' }}>Breakdown by variant:</div>
                                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '2px' }}>
                                                {variantEntries.map(([variant, qty]) => <span key={variant} style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '12px', fontSize: '9px', fontWeight: 'bold' }}>{variant}: {qty}</span>)}
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      );
                                    })()}
                                  </div>
                                )}

                                {p.productName && isReelOrTotaOrRoll && stockByWeight && Object.keys(stockByWeight).length > 0 && (
                                  <div style={{ fontSize: '10px', color: '#0a8938', marginTop: '2px', fontWeight: '500', backgroundColor: '#e8f5e9', padding: '2px 4px', borderRadius: '4px' }}>
                                    📊 {Object.entries(stockByWeight).map(([w, q]) => `${w}: ${q}`).join(', ')}
                                  </div>
                                )}

                                {cat === 'roll' && !p.size && p.productName && (
                                  <div style={{ fontSize: '11px', color: '#ff4444', marginTop: '2px', fontWeight: '500' }}>⚠️ Size is required for roll products</div>
                                )}
                                {(cat === 'reel' || cat === 'tota' || cat === 'roll') && (!p.returnedQuantity || parseFloat(p.returnedQuantity) <= 0) && p.productName && (
                                  <div style={{ fontSize: '11px', color: '#ff9800', marginTop: '2px', fontWeight: '500' }}>
                                    ⚡ Enter {cat === 'roll' ? 'meters/units' : 'weight in kg'} in the Quantity column
                                  </div>
                                )}
                                {isReelOrTota && (!p.length || parseFloat(p.length) <= 0) && p.productName && (
                                  <div style={{ fontSize: '11px', color: '#ff9800', marginTop: '2px', fontWeight: '500' }}>
                                    ⚡ Length is required (e.g., meters)
                                  </div>
                                )}
                              </td>

                              <td>
                                <input list={`categories-${idx}`} value={p.category || ""} onChange={(e) => handleUpdateProductChange(idx, "category", e.target.value)} className="read-only-input" />
                                <datalist id={`categories-${idx}`}>
                                  {Array.isArray(categoryList) && categoryList.map((c, i) => <option key={i} value={c.categoryName} />)}
                                </datalist>
                              </td>

                              <td>
                                <input type="number" value={p.returnedQuantity ?? ""} onChange={(e) => handleUpdateProductChange(idx, "returnedQuantity", e.target.value)} className="read-only-input" placeholder={(cat === 'reel' || cat === 'tota') ? "Weight in kg" : (cat === 'roll' ? "Quantity in meters" : "Return Qty")} step={(cat === 'reel' || cat === 'tota') ? "1" : "0.01"}   onWheel={(e) => e.preventDefault()}   // ✅ add this
/>
                              </td>

                              <td>
                                <input type="number" value={p.price ?? ""} onChange={(e) => handleUpdateProductChange(idx, "price", e.target.value)} className="read-only-input"   onWheel={(e) => e.preventDefault()}   // ✅ add this
/>
                              </td>

                              {/* SINGLE Size column in update form */}
                              {showSize && (
                                <td>
                                  {(isPacket || isRoll) ? (
                                    <input type="number" value={p.size ?? ""} onChange={(e) => handleUpdateProductChange(idx, "size", e.target.value)} className="read-only-input" placeholder={isRoll ? "Size (e.g., 18)" : "Size"} style={{ borderColor: (isRoll && !p.size && p.productName) ? '#ff4444' : '' }}   onWheel={(e) => e.preventDefault()}   // ✅ add this
/>
                                  ) : isReelOrTota ? (
                                    <input type="number" step="any" value={p.length ?? ""} onChange={(e) => handleUpdateProductChange(idx, "length", e.target.value)} className="read-only-input" placeholder="Length (m)" style={{ borderColor: (!p.length && p.productName) ? '#ff4444' : '' }}   onWheel={(e) => e.preventDefault()}   // ✅ add this
/>
                                  ) : (
                                    <input type="text" value="" className="read-only-input" disabled style={{ backgroundColor: '#f0f0f0' }} placeholder="N/A" />
                                  )}
                                </td>
                              )}

                              {showPacketColumns && (
                                <>
                                  <td>{isPacket ? <input type="number" value={p.ktae ?? ""} onChange={(e) => handleUpdateProductChange(idx, "ktae", e.target.value)} className="read-only-input" placeholder="Ktae"   onWheel={(e) => e.preventDefault()}   // ✅ add this
/> : <input type="text" value="" className="read-only-input" disabled style={{ backgroundColor: '#f0f0f0' }} placeholder="N/A"   onWheel={(e) => e.preventDefault()}   // ✅ add this
/>}</td>
                                  <td>{isPacket ? <input type="number" value={p.gram ?? ""} onChange={(e) => handleUpdateProductChange(idx, "gram", e.target.value)} className="read-only-input" placeholder="Gram"   onWheel={(e) => e.preventDefault()}   // ✅ add this
/> : <input type="text" value="" className="read-only-input" disabled style={{ backgroundColor: '#f0f0f0' }} placeholder="N/A"   onWheel={(e) => e.preventDefault()}   // ✅ add this
/>}</td>
                                </>
                              )}

                              {showBoxColumns && (
                                <>
                                  <td>{cat === 'box' ? <input type="text" value={p.boxSize ?? ""} onChange={(e) => handleUpdateProductChange(idx, "boxSize", e.target.value)} className="read-only-input" placeholder="Box Size" /> : <input type="text" value="" className="read-only-input" disabled style={{ backgroundColor: '#f0f0f0' }} placeholder="N/A" />}</td>
                                  <td>{cat === 'box' ? <input type="text" value={p.particular ?? ""} onChange={(e) => handleUpdateProductChange(idx, "particular", e.target.value)} className="read-only-input" placeholder="Particular" /> : <input type="text" value="" className="read-only-input" disabled style={{ backgroundColor: '#f0f0f0' }} placeholder="N/A" />}</td>
                                </>
                              )}

                              {/* Particular Column - Show for all categories except roll */}
                              {showParticularColumn && (
                                <td>
                                  {cat !== 'roll' ? (
                                    (cat === 'reel' || cat === 'tota') ? (
                                      <>
                                        <input type="text" list={`vendors-${idx}`} value={p.particular ?? ""} onChange={(e) => handleUpdateProductChange(idx, "particular", e.target.value)} className="read-only-input" placeholder="Select Vendor Name" style={{ borderColor: (!p.particular && p.productName) ? '#ff4444' : '' }} />
                                        <datalist id={`vendors-${idx}`}>
                                          {vendorList.map(vendor => <option key={vendor.id} value={vendor.vendorName} />)}
                                        </datalist>
                                        {!p.particular && p.productName && <div style={{ fontSize: '11px', color: '#ff4444', marginTop: '2px' }}>⚠️ Vendor name required</div>}
                                        {p.particular && <div style={{ fontSize: '10px', color: '#0a8938', marginTop: '2px' }}>✅ Returning to vendor: {p.particular}</div>}
                                      </>
                                    ) : (
                                      <input type="text" value={p.particular ?? ""} onChange={(e) => handleUpdateProductChange(idx, "particular", e.target.value)} className="read-only-input" placeholder="Particular" />
                                    )
                                  ) : (
                                    <input type="text" value="" className="read-only-input" disabled style={{ backgroundColor: '#f0f0f0' }} placeholder="Not applicable for Roll" />
                                  )}
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="invoice-summary" style={{ color: "#000", marginTop: 10 }}>
                  <p>
                    <strong>Customer Name:</strong>
                    <input type="text" list="customerNamesUpdate" value={updateInvoice.customerName ?? ""} onChange={handleUpdateCustomerChange} className="read-only-input" placeholder="Select Customer" disabled={isUpdating} />
                    <datalist id="customerNamesUpdate">
                      {customerList.map(c => <option key={c.id} value={c.customerName}>{c.customerName} {c.currentBalance !== undefined ? `(Balance: ${c.currentBalance})` : ''}</option>)}
                    </datalist>
                    {selectedCustomerBalance !== null && <span style={{ marginLeft: '10px', fontSize: '12px', color: '#0a8938' }}>Current Balance: Rs {selectedCustomerBalance.toFixed(2)}</span>}
                  </p>
                  <p><strong>Discount:</strong> <input type="number" value={updateInvoice.invoiceDiscount ?? ""} onChange={(e) => handleUpdateInvoiceField("invoiceDiscount", e.target.value)} className="read-only-input"   onWheel={(e) => e.preventDefault()}   // ✅ add this
/></p>
                  <p><strong>Rent:</strong> <input type="number" value={updateInvoice.invoiceRent ?? ""} onChange={(e) => handleUpdateInvoiceField("invoiceRent", e.target.value)} className="read-only-input"   onWheel={(e) => e.preventDefault()}   // ✅ add this
/></p>
                  <p><strong>GST Percentage:</strong> <input type="number" value={updateInvoice.gstPercentage ?? ""} onChange={(e) => handleUpdateInvoiceField("gstPercentage", e.target.value)} className="read-only-input" step="0.01" placeholder="e.g., 18"   onWheel={(e) => e.preventDefault()}   // ✅ add this
/></p>
                  {updateInvoice.gstPercentage > 0 && (
                    <p><strong>GST Amount:</strong> {(() => {
                      const productsTotal = (updateInvoice.sales || []).reduce((sum, p) => sum + (parseFloat(p.calculatedTotal) || 0), 0);
                      const discount = parseFloat(updateInvoice.invoiceDiscount) || 0;
                      const rent = parseFloat(updateInvoice.invoiceRent) || 0;
                      const gstPercent = parseFloat(updateInvoice.gstPercentage) || 0;
                      const subtotalBeforeGst = productsTotal - discount + rent;
                      const gstAmount = (subtotalBeforeGst * gstPercent / 100).toFixed(2);
                      return gstAmount;
                    })()}</p>
                  )}
                  <p><strong>Description:</strong> <input type="text" value={updateInvoice.description ?? ""} onChange={(e) => handleUpdateInvoiceField("description", e.target.value)} className="read-only-input" style={{ width: "60%" }} /></p>
                  <p className="grand-total"><strong>Amount Payable:</strong> {updateInvoice.grandTotal ?? "0"}</p>
                </div>

                <div style={{ marginTop: 12, display: "flex", gap: 10 }}>
                  <button className="save-btn" onClick={saveUpdate} disabled={isUpdating} style={{ opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer' }}>{isUpdating ? 'Saving...' : 'Save Updated Invoice'}</button>
                  <button className="remove-btn" onClick={() => setUpdateInvoice(null)} disabled={isUpdating}>Cancel</button>
                </div>
              </div>
            )}

            <div className="invoice-summary" style={{ color: "#000", marginTop: 10 }}>
              <p><strong>Discount:</strong> {invoice.invoiceDiscount ?? "0"}</p>
              <p><strong>Rent:</strong> {invoice.invoiceRent ?? "0"}</p>
              {invoice.gstPercentage > 0 && (
                <>
                  <p><strong>GST ({invoice.gstPercentage}%):</strong> {invoice.gstAmount ?? "0"}</p>
                  <p><strong>Subtotal before GST:</strong> {invoice.totalBeforeGst ?? "0"}</p>
                </>
              )}
              <p><strong>Description:</strong> {invoice.description ?? "—"}</p>
              <p className="grand-total"><strong>Amount Payable:</strong> {invoice.grandTotal ?? "0"}</p>
            </div>
          </div>
        );
      })}

      <div style={{ position: "absolute", top: "-9999px" }}>
        <UniversalInvoicePrint ref={printRef} invoice={printInvoice} type="saleReturn" />
      </div>

      {fullScreenImage && (
        <div onClick={() => setFullScreenImage(null)} style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.8)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, cursor: "zoom-out" }}>
          <img src={fullScreenImage} alt="Full Screen Invoice" style={{ maxWidth: "90%", maxHeight: "90%", objectFit: "contain", boxShadow: "0 0 20px #fff" }} />
        </div>
      )}
    </div>
  );
}

export default ViewSalesReturn;